const {
  SPELL_CONFUSION,
  SPELL_DETECT_MAGIC,
  SPELL_DISPEL_MAGIC,
  SPELL_FEAR,
  SPELL_INVISIBILITY,
  SPELL_SPIRITUAL_WEAPON,
  SPELL_TELEPORT,
} = require('./../../../../spellIdList')
const {
  DAMAGE_BLUDGEONING,
  DAMAGE_COLD,
  DAMAGE_ELECTRICITY,
  DAMAGE_FIRE,
  DAMAGE_NONMAGIC_WEAPON,
  DAMAGE_PIERCING,
  DAMAGE_POISON,
} = require('./../../../../damageTypeList')
const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  CREATURE_BAPHOMET,
  CREATURE_GHOUL,
  CREATURE_GNOLL,
  CREATURE_HYENA,
  CREATURE_YEENOGHU,
} = require('./../../../../creatureIdList')
const {
  CONDITION_CHARMED,
  CONDITION_EXHAUSTION,
  CONDITION_FRIGHTENED,
  CONDITION_POISONED,
} = require('./../../../../conditionList')
const {
  CREATURE_TYPE_DEMON,
  CREATURE_TYPE_DEMON_LORD,
  CREATURE_TYPE_FIEND,
} = require('./../../../../creatureTypeIdList')
const {
  ABILITY_LEGENDARY_RESISTANCE_3,
  ABILITY_MAGIC_RESISTANCE,
  ABILITY_MAGIC_WEAPONS,
} = require('./../../../../creatureAbilityList')
const {
  LANG_ALL,
  LANG_TELEPATHY,
} = require('./../../../../languageIdList')
const {
  SKILL_INTIMIDATION,
  SKILL_PERCEPTION,
} = require('./../../../../skillList')
const {ALIGNMENT_CE} = require('./../../../../aligmentList')
const {ARMOR_TYPE_NATURAL} = require('./../../../../armorTypeList')
const {ATTACK_MELEE_WEAPON} = require('./../../../../attackTypeList')
const {CAST_MATERIAL} = require('./../../../../castComponentList')
const {CR_24} = require('./../../../../crList')
const {demonDescription} = require('./../../../../textCommonParts')
const {PROF_NORMAL} = require('./../../../../proficiencyList')
const {SENSE_TRUE_VISION} = require('./../../../../senseList')
const {SIZE_HUGE} = require('./../../../../sizeList')
const {
  SOURCE_GAME_BG_3,
  SOURCE_MTOF,
} = require('./../../../../sourceList')
const {SPEED_WALK} = require('./../../../../speedList')

module.exports = {
  name: 'Йеногу',
  nameAlt: [
    'Зверь-мясник',
    'Зверь резни',
    'Повелитель гноллов',
  ],
  nameEn: 'Yeenoghu',
  id: CREATURE_YEENOGHU,
  hasSpoilers: true,
  description: [
    `Зверь Мясник представляет собой огромного покрытого боевыми шрамами [гнолла](CREATURE:${CREATURE_GNOLL}) высотой в 14 футов. Йеногу — Лорд Гноллов, а его создания выглядят как его извращенные подобия. Когда лорд демонов охотится в Материальном плане, стаи [гиен](CREATURE:${CREATURE_HYENA}) следуют за ним по пятам. Те из них, что съедают жертв Йеногу, становятся гноллами, следующими принципам своего повелителя. Есть также те, кто поклоняется Зверю Мяснику, и они, как правило, заимствуют внешность и повадки гноллов — ходят, сгорбившись и стачивают свои зубы, чтобы сделать их заострёнными.

Йеногу не интересует ничего кроме бойни и бессмысленного разрушения. Для него гноллы лишь пешки, которых он посылает творить жесточайшие зверства в свою честь. Йеногу получает удовольствие, когда вызывает в жертвах страх перед тем, как их убить, и сеет скорбь и отчаяние, уничтожая то, что им дорого больше всего. Он не ведёт переговоров. Встретившись с ним, можно лишь сразиться с ним, за исключением тех случаев, когда ему скучно. У Зверя Мясника давняя вражда с [Бафометом, Рогатым Королем](CREATURE:${CREATURE_BAPHOMET}), и два этих лорда демонов, а также их последователи, нападают друг на друга лишь завидев.

Властелин Гноллов облачён в грязные меха и облезлые шкуры, а его лицо подобно черепу скалящегося хищника. Лоскутные доспехи изготовлены из старых щитов и нагрудников, закрепленных на его теле тяжёлыми цепями, украшенными шкурами, содранными с его врагов. Он носит трёхглавый цеп по имени Мясник, который может вызывать в руки по своему желанию, хотя он, как правило, обычно терзает свою жертву голыми руками, а затем зубами разрывает горло.`,
    {
      header: 'Владыки безумия, ч.4: Йеногу',
      text: `Из всех лордов демонов мало кому удалось оставить такой значительный след в мире, как Йеногу. Предполагается, его неукротимый голод — не более чем безмозглый инстинкт, но при всё этом, нет ничего безмозглого в планомерном разложении мира посредством его избранного народа — [гноллов](CREATURE:${CREATURE_GNOLL}). Как же появляются на свет гноллы? Вначале избранник Йеногу следует приказу хозяина — убивает. Затем [гиены](CREATURE:${CREATURE_HYENA}) пируют на трупах — и из забитого тухлятиной чрева [гиены](CREATURE:${CREATURE_HYENA}) рождается гнолл. Таким образом рождённый [гнолл](CREATURE:${CREATURE_GNOLL}) — это воплощённый голод. Они пожирают любых живых существ, разрывают мясо и обгладывают кости, оставляя за собой лишь голые белые осколки. Их не волнует богатство или стяжательство — они заняты лишь насыщением своего голода. Это насыщение само по себе является жертвой Йеногу и отправляется прямо к нему. Кое-кто может позавидовать [гноллам](CREATURE:${CREATURE_GNOLL}), связанным материальной связью с богом-творцом, но эта зависть растворится в кромешном ужасе, лишь только эти твари наводнят своим зловонным дыханием и безумным хеканьем темноту ночи.
      
Если вы поймёте что вас преследуют [гноллы](CREATURE:${CREATURE_GNOLL}) — сжигайте тела умерших, отбивайте свой запах и молитесь любому, кто поможет, ибо ни взятка, ни мольбы, ни уговоры не помогут, когда на тебя охотится голод во плоти.`,
      source: {
        id: SOURCE_GAME_BG_3,
      },
    },
    {
      header: 'Логово Йеногу',
      text: `Логово Йеногу в Бездне известно под названием Долина Смерти, бесплодные холмы и лощины которой служат ему охотничьими угодьями, в которых он преследует смертных жертв его жестокой игры. Логово Йеногу — это кровавая обитель смерти, кишащая [гноллами](CREATURE:${CREATURE_GNOLL}), [гиенами](CREATURE:${CREATURE_HYENA}) и [упырями](CREATURE:${CREATURE_GHOUL}), и на этом слое Бездны почти нет строений или каких-либо признаков цивилизации.

# Действия логова

По очереди инициативы 20 (проигрыш при ничье), Йеногу может совершить действие в логове, чтобы создать один из следующих магических эффектов; он не может использовать один и тот же эффект два раунда подряд:

* Йеногу заставляет железный шип — 5 футов в длину и 1 дюйм в диаметре — вырваться из земли в точке, которую он может видеть, и которая находится не дальше 100 футов от него. Любое существо, находящееся в том пространстве, где появляется шип, должно пройти испытание Ловкости СЛ 24. При провале существо получит колющий урон 27 (6к8) и будет обездвиженым, будучи насаженным на шип. Существо может потратить действие на то, чтобы слезть (или снять кого-либо) с шипа, завершая тем самым состояние обездвиженности. 
* Каждый гнолл или гиена, которых Йеногу может видеть, могут потратить реакцию, чтобы совершить перемещение со своей скоростью. 
* До следующего счета инициативы 20 все [гноллы](CREATURE:${CREATURE_GNOLL}) и [гиены](CREATURE:${CREATURE_HYENA}), находящиеся в логове, входят в состояние ярости, при котором получают преимущество на броски атаки рукопашным оружием, и броски атаки по ним также проходят с преимуществом.

# Местные эффекты

Область, в которой расположено логово Йеногу пронизана его магией, создающей в ней один или более из следующих эффектов:

* В пределах 1 мили от логова из земли и камней торчат железные шипы. Йеногу насаживает своих убитых жертв на них. 
* Хищные звери в пределах 6 миль от логова необычайно дикие, и убивают гораздо больше, чем им нужно для пропитания. Тела их жертв остаются гнить, образуя неестественный пейзаж бессмысленной бойни. 
* Если гуманоид проводит по крайней мере 1 час на расстоянии 1 мили от логова, то это существо должно пройти испытание Мудрости СЛ 17 или станет жертвой безумия, определяемого по таблице _Безумие Йеногу_. Существо, успешно прошедшее испытание, не может стать жертвой этого регионального эффекта в течение следующих 24 часов.

Если Йеногу умирает, эти эффекты прекращаются в течение 1к10 дней.`,
      source: {
        id: SOURCE_MTOF,
        page: 151,
      },
    },
    {
      header: 'Безумие Йеногу',
      text: `Если существо становится безумным в логове Йеногу или в поле зрения этого лорда демонов, совершите бросок по таблице Безумие Йеногу, чтобы определить природу безумия, которое будет слабостью персонажа и будет действовать до тех пор, пока не будет излечено.

| к100  | Слабость (длится пока не будет вылечена) |
|-------|------------------------------------------|
| 01-20 | _«Меня охватывает гнев, и я пытаюсь разжечь его в окружающих, чтобы собрать разъяренную толпу»_ |
| 21-40 | _«Плоть других разумных существ восхитительна на вкус»_ |
| 41-60 | _«Я осуждаю законы и обычаи цивилизации и стремлюсь вернуться в более примитивные времена»_ |
| 61-80 | _«Я жажду смертей, и я сразу начинаю сражение в надежде увидеть кровопролитие»_ |
| 81-00 | _«Я собираю трофеи с трупов тех, кого я убил, делая из них украшения»_ |
`,
      source: {
        id: SOURCE_MTOF,
        page: 152,
      },
    },
    ...demonDescription,
  ],
  sizeType: SIZE_HUGE,
  creatureTypeIdList: [
    CREATURE_TYPE_FIEND,
    CREATURE_TYPE_DEMON,
    CREATURE_TYPE_DEMON_LORD,
  ],
  alignmentId: ALIGNMENT_CE,
  source: {
    id: SOURCE_MTOF,
    page: 151,
  },
  armor: {
    ac: 22,
    type: ARMOR_TYPE_NATURAL,
  },
  hp: {
    diceCount: 23,
  },
  speed: {
    [SPEED_WALK]: 50,
  },
  params: {
    [PARAM_STR]: 29,
    [PARAM_DEX]: 16,
    [PARAM_CON]: 23,
    [PARAM_INT]: 15,
    [PARAM_WIT]: 24,
    [PARAM_CHA]: 15,
  },
  saveThrowList: [
    PARAM_DEX,
    PARAM_CON,
    PARAM_WIT,
  ],
  skillCollection: {
    [SKILL_INTIMIDATION]: PROF_NORMAL,
    [SKILL_PERCEPTION]: PROF_NORMAL,
  },
  resistanceList: [
    DAMAGE_COLD,
    DAMAGE_FIRE,
    DAMAGE_ELECTRICITY,
  ],
  immunityList: [
    DAMAGE_POISON,
    DAMAGE_NONMAGIC_WEAPON,
  ],
  immunityConditionList: [
    CONDITION_CHARMED,
    CONDITION_EXHAUSTION,
    CONDITION_FRIGHTENED,
    CONDITION_POISONED,
  ],
  senseList: [
    {
      id: SENSE_TRUE_VISION,
      value: 120,
    },
  ],
  languageList: [
    LANG_ALL,
    {
      id: LANG_TELEPATHY,
      range: 120,
    },
  ],
  cr: CR_24,
  featureList: [
    ABILITY_LEGENDARY_RESISTANCE_3,
    ABILITY_MAGIC_RESISTANCE,
    ABILITY_MAGIC_WEAPONS,
    {
      name: 'Неистовство',
      description: `Когда Йеногу снижает хиты существа до 0 рукопашной атакой в своем ходу, Йеногу может потратить бонусное действие для того, чтобы совершить перемещение на половину своей скорости и совершить атаку _Укусом_.`,
    },
  ],
  spellCast: {
    baseStat: PARAM_CHA,
    componentExclude: CAST_MATERIAL,
    spellIdByCountList: [
      {
        limit: Infinity,
        list: [
          SPELL_DETECT_MAGIC,
          {
            id: SPELL_SPIRITUAL_WEAPON,
            comment: '8 круг заклинания, при попадании 4к8 + 2 урона силовым полем, имеет вид цепа',
          },
        ],
      },
      {
        limit: {
          count: 3,
          period: 'день',
        },
        list: [
          SPELL_DISPEL_MAGIC,
          SPELL_FEAR,
          SPELL_INVISIBILITY,
        ],
      },
      {
        limit: {
          count: 1,
          period: 'день',
        },
        list: [
          SPELL_TELEPORT,
        ],
      },
    ],
  },
  actionList: [
    {
      name: 'Мультиатака',
      description: `Йеногу совершает три атаки _цепом_. Если атака поражает цель, он может создать дополнительный эффект по своему выбору или случайным образом (каждый эффект может быть использован только единожды за одну Мультиатаку):

1. Атака наносит дополнительно 13 (2к12) дробящего урона.
2. Цель должна пройти испытание Телосложения СЛ 17 или будет парализована до начала следующего хода Йеногу.
3. Цель должна пройти испытание Мудрости СЛ 17 или станет жертвой эффекта заклинания [смятение](SPELL:${SPELL_CONFUSION}) до начала следующего хода Йеногу.`,
    },
    {
      name: 'Цеп',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 16,
        range: 15,
        hit: {
          type: DAMAGE_BLUDGEONING,
          diceCount: 2,
          diceType: 12,
          diceBonus: 9,
        },
      },
    },
    {
      name: 'Укус',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 16,
        range: 10,
        hit: {
          type: DAMAGE_PIERCING,
          diceCount: 4,
          diceType: 10,
          diceBonus: 9,
        },
      },
    },
  ],
  legendaryPoints: 3,
  legendaryActionList: [
    {
      name: 'Наступление',
      description: `Йеногу перемещается на свою скорость.`,
    },
    {
      name: 'Удар наотмашь',
      description: `Йеногу совершает атаку цепом. Если атака успешна, цель должна пройти испытание Силы СЛ 24 или будет отброшена на 15 футов по прямой линии от Йеногу. Если испытание провалено на 5 или более, цель падает ничком.`,
    },
    {
      name: 'Дикость',
      cost: 2,
      description: `Йеногу атакует _Укусом_ каждое существо в пределах 10 футов от него.`,
    },
  ],
}
